import React from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import { BiEdit } from 'react-icons/bi';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { updateReceiptType, deleteReceiptType } from '../../../usecases/receipts-usecase';
import ReceiptTypeForm from '../ReceiptTypeForm/view';

function EditReceiptType({ data }) {

    function handleSubmit(payload) {
        updateReceiptType(data.id, payload).then(res => {
            dispatchCustomEvent("popup", { message: "Tipo de Recibo Actualizado" });
            dispatchCustomEvent("close-edit-receipt-type-" + data.id + "-modal", {});
            dispatchCustomEvent("update-receipt-types", {});
        }).catch(err => {
            if (err.status === 429) {
                dispatchCustomEvent("popup", { message: "Alcanzaste el limite" });
            } else {
                dispatchCustomEvent("popup", { message: err.response?.data?.message || "Error al actualizar tipo de recibo", type: "error" });
            }
            dispatchCustomEvent("loading-btn", {});
        });
    }

    function handleDelete() {
        deleteReceiptType(data.id).then(res => {
            dispatchCustomEvent("popup", { message: "Tipo de Recibo Eliminado" });
            dispatchCustomEvent("close-edit-receipt-type-" + data.id + "-modal", {});
            dispatchCustomEvent("update-receipt-types", {});
        }).catch(err => {
            if (err.status === 429) {
                dispatchCustomEvent("popup", { message: "Alcanzaste el limite" });
            } else {
                dispatchCustomEvent("popup", { message: err.response?.data?.message || "Error al eliminar tipo de recibo", type: "error" });
            }
            dispatchCustomEvent("loading-btn", {});
        });
    }

    return (
        <ModalBtn
            id={'edit-receipt-type-' + data.id}
            title={<BiEdit />}
            type="action"
            style={{ width: '65vw', maxWidth: '95vw' }}
        >
            <ReceiptTypeForm
                initialData={data}
                onSubmit={handleSubmit}
                loadingId="edit-receipt-type-btn"
                title={`Editar Tipo de Recibo: ${data?.name || ''}`}
                submitLabel="Guardar Cambios"
                showDelete={true}
                onDelete={handleDelete}
            />
        </ModalBtn>
    );
}

export default EditReceiptType;
